export default {
  methods:{
    tituloURL(titulo){
      let tituloNuevo = titulo;
      let huboEspacio = true;

      while(huboEspacio){
          if(tituloNuevo.indexOf(' ') > 0){
              tituloNuevo = tituloNuevo.replace(' ', '-');
              tituloNuevo = tituloNuevo.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          }
          else huboEspacio = false;
      }
      return tituloNuevo;
    },
  },

};

